import { render, staticRenderFns } from "./country.vue?vue&type=template&id=5be474bd&scoped=true&"
import script from "./country.vue?vue&type=script&lang=js&"
export * from "./country.vue?vue&type=script&lang=js&"
import style0 from "./country.vue?vue&type=style&index=0&id=5be474bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be474bd",
  null
  
)

export default component.exports